<template>
  <el-dialog :visible.sync="isShowDialog" width="660px">
    <div class="title">
      <I18nLang :data="header_area" />
    </div>
    <div class="fix_height">
      <div class="desc">
        <I18nLang :data="desc_area" />
      </div>
      <div class="note_area">
        <ul :style="{ listStyle: listSymbol }">
          <li v-for="note in note_area_list" :style="{ listStyle: listSymbol }">
            <I18nLang :data="note" tag="p" />
          </li>
        </ul>
      </div>
    </div>
    <el-button class="ok-btn" type="primary" @click="onOk">
      <I18nLang :data="button_area" />
    </el-button>
  </el-dialog>
</template>

<script>
import I18nLang from '@/components/deposit/paymentCenterSystem/I18nLang.vue';

export default {
  name: 'PcsPopup',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    popupData: {
      type: Object || null,
      default: () => {}
    },
    sensorsClick: {
      type: Function
    }
  },
  components: { I18nLang },
  computed: {
    isShowDialog: {
      get() {
        return this.dialogVisible;
      },
      set(newValue) {
        this.$emit('update:dialogVisible', newValue);
        return newValue;
      }
    },
    header_area() {
      return this.popupData?.header_area || null;
    },
    desc_area() {
      return this.popupData?.desc_area || null;
    },
    note_area() {
      return this.popupData?.note_area || null;
    },
    note_area_list() {
      return this.popupData?.note_area?.note_list || [];
    },
    listSymbol() {
      switch (this?.popupData?.note_area?.list_symbol) {
        case 0:
          return 'decimal';
        case 1:
          return 'alphabet';
        case 2:
          return 'none';
        case 3:
          return 'square';
        case 4:
          return 'circle';
        case 5:
          return 'star';
        default:
          return 'none';
      }
    },
    button_area() {
      return this.popupData?.button_area || null;
    }
  },
  methods: {
    onOk() {
      this.isShowDialog = false;
      this.sensorsClick?.('DEPOSIT_STEP2_IBTPAGETERMSPOPUP_CONFIRM_CLICK');      
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  color: $red-orange;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.fix_height {
  height: 60vh;
  overflow: auto;
  padding: 0 15px;
  margin: 20px 0;
  word-wrap: break-word;
}

.desc {
  text-align: center;
  > div {
    color: $PCS-main-text;
    font-size: 16px;
    padding: 20px 0;
    line-height: 20px;
  }
}
.note_area {
  @include rtl-sass-prop(padding-left, padding-right, 30px);
  color: rgba($PCS-main-text, 0.65);
  div {
    line-height: 20px;
    color: rgba($PCS-main-text, 0.65);
  }
}

.ok-btn {
  margin-top: 20px;
  width: 100%;
  border-radius: 100px;
}

.text-btn {
  color: $red-orange;
  margin: 20px 0 0 0;
  padding: 0;
  text-align: center;
  width: 100%;
  &:hover,
  &:active,
  &:focus,
  &:not(:hover) {
    color: $red-orange;
    border: none;
    background: none;
  }
}
</style>
